import { useEffect, useState } from 'react';
import { Icon } from "@iconify/react";
import plusFill from '@iconify/icons-eva/plus-fill';
import editFill from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import moment from 'moment';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Switch,
} from '@mui/material';
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';

import MoreMenu from 'src/components/common/MoreMenu';
import MyPagination from 'src/components/common/MyPagination';
import ListHead from 'src/components/common/ListHead';
import { BASE_URL, IMG_BASE_URL } from 'src/config/constants';
import Confirm from 'src/components/common/ConfirmDialog';
import ListToolbar from 'src/components/common/ListToolbar';
import CellImage from 'src/components/common/CellImage';
import { asyncRequest } from 'src/services/network';
import CouponEdit from './components/CouponEdit';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'name', label: '名称', alignRight: false },
  // { id: 'category', label: '分类', alignRight: false },
  { id: 'type', label: '类型', alignRight: false },
  { id: 'discount', label: '面值', alignRight: false },
  { id: 'time', label: '有效期', alignRight: false },
  { id: 'stock', label: '发布数量', alignRight: false },
  { id: 'status', label: '状态', alignRight: false },
  { id: 'created', label: '发布时间', alignRight: false },
  { id: '' }
];

const moreMenus = [
  { title: "编辑", icon: editFill },
  { title: "删除", icon: iconDelete },
];

export default function CouponList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState('');
  const [targetItem, setTargetItem] = useState({});

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: '/coupon/list',
      data: filter,
    })

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setTargetItem(row)
      setAction('edit')
    } else if (type === "删除") {
      handleDelItem(row);
    }
  };

  function handleDelItem({ id }) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      async onConfirm() {
        await asyncRequest({
          path: "/coupon/del",
          data: { id }
        });

        setItems(items.filter((b) => b.id !== id));
      },
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="优惠券列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            优惠券列表
          </Typography>

          <Button
            variant="contained"
            // component={RouterLink}
            // to="/marketing/coupon/add"
            startIcon={<Icon icon={plusFill} />}
            onClick={() => {
              setAction('add')
            }}
          >
            添加优惠券
          </Button>
        </Stack>

        <Card>
          <ListToolbar
            numSelected={selected.length}
            filterName={filter.search}
            onRefresh={getItems}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead
                  headLabel={TABLE_HEAD}
                />
                <TableBody>
                  {items
                    .map((row) => {
                      const { id, name, cover, status, categoryId, type, reach, worth, discount, stock, createdAt, startTime, endTime } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">{id}</TableCell>
                          <TableCell align="left">{name}</TableCell>
                          {/* <TableCell align="left">
                            <CellImage src={cover} />
                          </TableCell> */}
                          {/* <TableCell align="left">{['', '商城', '土地', '认养', '活动'][categoryId]}</TableCell> */}
                          <TableCell align="left">{['', '洗车券', '油卡', '电卡', '养车券'][type]}</TableCell>
                          <TableCell align="left">{worth}</TableCell>
                          <TableCell align="left">{startTime ? moment(startTime).format("YYYY-MM-DD HH:mm:ss") : null}</TableCell>
                          <TableCell align="left">{stock || '无限制'}</TableCell>
                          <TableCell align="left">
                            <Switch checked={status == 1} />
                          </TableCell>
                          <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                          <TableCell align="right">
                            <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>


          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      {(action == 'add' || action == 'edit') && (
        <CouponEdit
          open
          item={targetItem}
          onClose={() => setAction('')}
          onFinish={() => {
            getItems();
            setAction('')
          }}
        />
      )}
    </Page>
  );
}
